// import React from "react";

// export default function marqueeServices(){
//     return(
// <div id="marquee" style={{ marginTop: '80px', padding: '0 20px' }}>
//   <h2>MARQUE PROJECTS</h2>
//   <p>We specialize in detailed and professional interior painting for homes, offices, and commercial buildings.</p>
//  <div
//   style={{
//     columnCount: 4,
//     columnGap: '1rem',
//     padding: '20px',
//   }}
// >
//   {[
//     '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//     '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//     '/Gallerypics/76608295b5e9c1f4bc3b6951da090bff.jpg',
//     '/Gallerypics/51af35d219d4ee84b5507f4680d57c9f.jpg',
//     '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',
//     '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/Javed.jpg',
//       '/Gallerypics/Servicepics/photo-1454165804606-c3d57bc86b40.jpeg',
//       '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',
//       '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//     // add more images
//   ].map((src, i) => (
//     <img
//       key={i}
//       src={src}
//       alt=""
//       style={{
//         width: '100%',
//         borderRadius: '8px',
//         marginBottom: '1rem',
//         breakInside: 'avoid',
//       }}
//     />
//   ))}
// </div>
//  </div>

//     );
// }




import React from "react";
// import "./serviceDetail.css";
// import ServiceContactForm from "../pages/servicecontactform";
import ContactForm from "../pages/Contact";



export default function MarqueePainting() {
  return (
    <div className="page-container">

      {/* Hero */}
      <section
        className="hero"
        style={{ backgroundImage: "url('/Gallerypics/170ff44e2859fd1e9f2cf19776ef55ab.jpg')" }}
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title">Marquee Painting</h1>
      </section>

      {/* Intro */}
      <section className="section">
        <p>
          Our marquee painting services bring life and elegance to your event spaces. 
          With premium paints and decorative finishes, we ensure your marquees look stunning 
          for weddings, corporate functions, and special celebrations.
        </p>
      </section>

      {/* Why Choose Us */}
      <section className="section bg-light">
        <h2>Why Choose Us</h2>
        <div className="why-list">
          <div className="why-item">
            <i className="fas fa-paint-brush"></i>
            <p>Decorative & theme-based painting</p>
          </div>
          <div className="why-item">
            <i className="fas fa-lightbulb"></i>
            <p>Custom designs to match event themes</p>
          </div>
          <div className="why-item">
            <i className="fas fa-clock"></i>
            <p>Quick setup and completion</p>
          </div>
          <div className="why-item">
            <i className="fas fa-star"></i>
            <p>Luxury finishes & detailing</p>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="section">
        <h2>Our Process</h2>
        <ol className="process-list">
          <li>Understanding your event theme</li>
          <li>Surface preparation</li>
          <li>Custom color mixing & painting</li>
          <li>Final decorative touches</li>
        </ol>
      </section>

      {/* Gallery */}
      <section className="section bg-light">
        <h2>Recent Projects</h2>
        <div className="gallery">
          <img src="/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg" alt="Marquee Project 1" />
          <img src="/Gallerypics/photo-1454165804606-c3d57bc86b40.jpeg" alt="Marquee Project 2" />
          <img src="/Project pics/Work7.JPG" alt="Marquee Project 3" />
        </div>
      </section>

      {/* Contact Form */}
      {/* <ServiceContactForm/> */}
      <ContactForm/>

    </div>
  );
}
